import CreateRoomSelect from "./CreateRoomSelect/CreateRoomSelect";
import {useState} from "react";
import Button from "../../../core/Button/Button";
import CreateRoomConventions from "./CreateRoomConventions";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import CreateRoomInput from "./CreateRoomInput/CreateRoomInput";
import {createRoom} from "../../../redux/actions/cash/actions";

function CreateForm() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {
        minBet,
        maxBet,
        defaultBet,
        stepTimes,
        tillValues,
        bankTimes,
        gameConventions,
        defaultConfig,
        bonusMinBet,
        bonusMaxBet
    } = useSelector(state => state.user.config);

    const waitingProcesses = useSelector(state => state.cash.waitingProcesses);

    const [formData, setFormData] = useState({
        step_time: stepTimes?.[defaultConfig?.stepTime],
        bank_time: bankTimes?.[defaultConfig?.bankTime],
        till_value: tillValues?.[defaultConfig?.till],
        combination_type: gameConventions?.[0]?.[defaultConfig?.conventionType]?.value,
        bet: defaultBet,
        without_boy: false,
        private_game: false,
        is_bonus: false,
    });
    const {isMobile ,currency}= useSelector(state => state.user)
    const minimalBet = formData?.is_bonus ? bonusMinBet : minBet;
    const maximalBet = formData?.is_bonus ? bonusMaxBet : maxBet;
    const createDisabled = formData?.bet < minimalBet || formData?.bet > maximalBet
    const handleConventionsChange = (data) => {
        setFormData({
            ...formData,
            ...data,
        })
    }
    const onCreate = () => {
        if (createDisabled) return;
        if (isMobile) dispatch(closeLobbyModal());
        dispatch(createRoom(formData))
    }
    return (
        <div className="create-room-wrapper">
            <div className="create-room-row">
                <CreateRoomInput
                    name="bet"
                    label={t("form.bet")}
                    placeholder={t("form.bet")}
                    handleConventionsChange={handleConventionsChange}
                    value={formData.bet}
                    minBet={minimalBet}
                    maxBet={maximalBet}
                    createDisabled={createDisabled}
                    currency={currency}
                />
                <CreateRoomSelect
                    name={'till_value'}
                    label={t("form.till")}
                    data={tillValues}
                    handleChange={handleConventionsChange}
                    value={formData.till_value}
                />
            </div>
            <div className="create-room-row">
                <CreateRoomSelect
                    name={'step_time'}
                    label={t("form.step_time")}
                    data={stepTimes}
                    handleChange={handleConventionsChange}
                    value={formData.step_time}
                />
                <CreateRoomSelect
                    name={'bank_time'}
                    label={t("form.bank_time")}
                    data={bankTimes}
                    handleChange={handleConventionsChange}
                    value={formData.bank_time}
                />
            </div>
            <CreateRoomConventions handleConventionsChange={handleConventionsChange}/>
            <div className="create-room-row">
                {
                    waitingProcesses.includes('creating')
                        ?
                        <Button type={"blue-border"} text={t("form.create_processing")} isDisabled={true}/>
                        :
                        <Button
                            type="green"
                            text={t("form.create_btn")}
                            onClick={onCreate}
                            cls={createDisabled ? "disabled-element" : ""}
                            isDisabled={createDisabled}
                        />
                }

            </div>

        </div>
    )
}

export default CreateForm